export default __webpack_public_path__ + "static/media/img_01.a117e224.jpg";